
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';

import LookupCustomerCode from '@/components/UI/LookupCustomerCode.vue';
import { clearPhoneNumber } from '@/utils/InputProcessingUtilities';

import { getReferencesParams } from '@/api';
import { BookingHeaderData, ReferencesParams, User } from '@/models/main';

@Component({
  components: {
    LookupCustomerCode,
  },
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})

// Parent component should have section with 'page-header' id and sections with 'attr-scroll-id="..."' attribute
export default class BookingHeader extends Vue {
  @Prop({ required: true }) public customerData;

  private user: User;

  public data = {
    customer_code: '',
    caller: '',
    phone: '',
    REF1: '',
    REF2: '',
    REF3: '',
    ref1_prompt: '',
    ref2_prompt: '',
    ref3_prompt: '',
    ref1_required: false,
    ref2_required: false,
    ref3_required: false,
  };

  private emitData(data: BookingHeaderData) {
    const updateData = {
      customer_code: data.customer_code,
      caller: data.caller,
      phone: data.phone,
      REF1: data.REF1,
      REF2: data.REF2,
      REF3: data.REF3,
    };
    this.$emit('dataChanged', updateData);
  }

  @Watch('data', { deep: true })
  private watchData() {
    this.emitData(this.data);
  }

  public async customerCodeChanged(code: string): Promise<void> {
    this.data.customer_code = code;
    if (code) {
      await this.getReferences(code);
    }
    this.emitData(this.data);
  }

  private async getReferences(customerCode) {
    await getReferencesParams(customerCode)
      .then((res: ReferencesParams) => {
        const updateData = {
          ...this.data,
        };
        //
        updateData.ref1_prompt = res.ref1_prompt || 'Reference 1';
        updateData.ref2_prompt = res.ref2_prompt || 'Reference 2';
        updateData.ref3_prompt = res.ref3_prompt || 'Reference 3';
        updateData.ref1_required = res.ref1_required || false;
        updateData.ref2_required = res.ref2_required || false;
        updateData.ref3_required = res.ref3_required || false;
        // For non-stuff user fill CCode, Caller and Phone
        if (!this.$ability.can('staff', 'Job')) {
          updateData.customer_code = this.user.customerCode;
          updateData.caller = this.user.username.split('@')[0].slice(0, 16);
          updateData.phone = this.user.phone_number ? clearPhoneNumber(this.user.phone_number) : '';
        }
        this.data = { ...updateData };
      })
      .catch(() => {
        this.$notify({
          group: 'network',
          title: "Error getting Customer's profile info",
          text: 'Something went wrong while make a request',
          type: 'warn',
          duration: 3000,
        });
      });
  }

  private async mounted() {
    await this.getReferences(this.user.customerCode);
  }
}
